// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"7d673d9e","453":"2ba23f7a","455":"22763976","889":"c710ce00","977":"fe27fa82"}[chunkId] + ".chunk.js";
};